import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import styled from 'styled-components'
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import MenuOpenIcon from '@material-ui/icons/MenuOpen';
import useMediaQuery from '@material-ui/core/useMediaQuery'
import TopAndBottomBar from '../components/TopAndBottomBar';
import NavMenu from '../components/NavMenu';
import OptionsMenu from '../components/courseContent/OptionsMenu';
import SideBar from '../components/Sidebar'
import CourseTitleBlock from '../components/courseContent/CourseTitleBlock';
import CourseSideBarItems from '../components/courseContent/CourseSideBarItems';
import MobileActionsBar from '../components/courseContent/MobileActionsBar'
import { useQuery, useLazyQuery } from '@apollo/react-hooks'
import { coursesQueries, modulesQueries } from '../graphql/queries';
import * as courseUtils from '../utils/course'
import { useParams, Redirect, useLocation } from 'react-router-dom';
import ContentRoutes from '../routes/ContentRoutes'
import logo from '../assets/images/logoNovo.png'
const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    height: '100%'
  },
  supportButton: {
    backgroundColor: '#3B86FF',
    color: '#fff',
    opacity: '1',
    '&:hover': {
      backgroundColor: '#3B86FF'
    }
  }
})
);

const Logo = styled.img`
  max-height: 28px;
  @media(max-width: 1050px) {
    max-height: 24px;
  }
`

const Course = () => {
  const classes = useStyles();
  const { id } = useParams()
  const { pathname } = useLocation()
  const conteudoId = pathname.replace(/\/curso\/[a-z0-9]*\//g, '')
  const isDefaultBreakpoint = useMediaQuery('(min-width:1050px)')
  const [open, setOpen] = useState(true);
  const { data: dataCourse } = useQuery(coursesQueries.GET_COURSE, { variables: { id } })
  const { data: dataLastContent } = useQuery(coursesQueries.GET_LAST_VISITED_CONTENT, {
    variables: {
      curso_id: id
    }
  })
  const [loadModule] = useLazyQuery(modulesQueries.GET_MODULES, { fetchPolicy: "network-only" })

  useEffect(() => {
    loadModule()
  }, []) //eslint-disable-line


  if (!conteudoId && ((dataLastContent || {}).ultimoConteudoAcessado || {})._id) {
    return <Redirect to={`/curso/${id}/${dataLastContent.ultimoConteudoAcessado._id}`} />
  }

  if (!conteudoId && ((dataCourse || {}).curso || {}).trilhas) {
    const firstContentId = courseUtils.getContentsFromTrails(dataCourse.curso.trilhas)[0]._id
    if (firstContentId) {
      return <Redirect to={`/curso/${id}/${firstContentId}`} />
    }
  }

  const handleDrawer = () => {
    setOpen(!open);
  };

  

  return isDefaultBreakpoint ? (
    <div className={classes.root}>
      <CssBaseline />
      <TopAndBottomBar open={open} topBar>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawer}
            edge="start"
            className={clsx(classes.menuButton, open && classes.hide)}
          >
            {open ? <MenuOpenIcon /> : <MenuIcon />}
          </IconButton>
          <Logo src={logo} />
        </div>
        <NavMenu menuIcon="options" courseId={id} forum={((dataCourse || {}).curso || {}).forum}>
          <OptionsMenu />
        </NavMenu>
      </TopAndBottomBar>
      <SideBar open={open}>
        <CourseTitleBlock course={(dataCourse || {}).curso}
          currentContent={conteudoId}
          trails={((dataCourse || {}).curso || {}).trilhas}
        />
        <CourseSideBarItems
          courseId={id}
          trails={((dataCourse || {}).curso || {}).trilhas}
          currentContent={conteudoId}
          cronograma={((dataCourse || {}).curso || {}).cronograma}
          apresentacao={((dataCourse || {}).curso || {}).apresentacao}
        />
      </SideBar>
      <ContentRoutes cursoId={id} open={open} trails={((dataCourse || {}).curso || {}).trilhas} cronograma={((dataCourse || {}).curso || {}).cronograma} apresentacao={((dataCourse || {}).curso || {}).apresentacao} progresso={((dataCourse || {}).curso || {}).progresso} />
    </div>
  ) : (
      <MobileActionsBar
        courseId={id}
        trails={((dataCourse || {}).curso || {}).trilhas}
        currentContent={conteudoId}
        cursoId={id}>
        <ContentRoutes cursoId={id} open={open} trails={((dataCourse || {}).curso || {}).trilhas} cronograma={((dataCourse || {}).curso || {}).cronograma} apresentacao={((dataCourse || {}).curso || {}).apresentacao} progresso={((dataCourse || {}).curso || {}).progresso}/>
      </MobileActionsBar>
    )
}
export default Course;
